import { Component, OnInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReleaseNoteService } from '../Services/release-note.service';
import { HeaderService } from '../Services/header.service';
import { ApplicationService } from '../Services/application.service';
import { IReleaseNote } from '../models/release-note.model';
import { QuillService } from '../Services/quill.service';

@Component({
  selector: 'app-notes-detail',
  templateUrl: './notes-detail.component.html',
  styleUrls: ['../app.component.scss', '../quill.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NotesDetailComponent implements OnInit, AfterViewChecked, OnDestroy {
  searchSub: Subscription;
  appSub: Subscription;
  constructor(private releaseNoteService: ReleaseNoteService, private applicationService: ApplicationService,
              private quillService: QuillService, private route: ActivatedRoute, private headerService: HeaderService,
              private router: Router) { }

  appName: string = this.route.snapshot.paramMap.get('appName');
  appID: number = +this.route.snapshot.paramMap.get('appID');
  month: number = +this.route.snapshot.paramMap.get('month');
  showNote: boolean[] = [];
  errorMessage = '';
  notes: IReleaseNote[];
  display: any[] = [];

  onSearch(term: string) {
    this.display = [];
    this.releaseNoteService.getMonthlyNotes(this.appID, this.month, term).subscribe({
      next: releaseNotes => {
        this.notes = releaseNotes.data;

        // sort by releasedate, version
        this.notes.sort((a, b) =>
          (a.releaseDate < b.releaseDate) ? 1 : (a.releaseDate > b.releaseDate) ? -1 :
            (a.versionNum < b.versionNum) ? 1 : (a.versionNum > b.versionNum) ? -1 :
              0);

        let i = 0;
        for (const note of this.notes) {
          this.showNote.push(i === 0);
          i++;
        }
      },
      error: err => this.errorMessage = err
    });
  }

  ngOnInit(): void {
    this.applicationService.checkApplication(this.appID, this.appName).then((resp) => {
      if (!resp) {
        this.router.navigate(['applications']);
      } else {
        this.searchSub = this.headerService.searchCommand$.subscribe((term) => {
          this.onSearch(term);
        });

        this.headerService.setBreadcrumbs(this.appName, this.appID, this.month);
        this.onSearch(this.headerService.searchTerm);
      }
    });
  }

  ngAfterViewChecked(): void {
    if (!document.getElementById('note-display0') && this.notes) {
      let i = 0;
      for (const note of this.notes) {
        const noteDisplay = document.createElement('div');
        noteDisplay.id = 'note-display' + i;
        noteDisplay.classList.add('note-display');

        const editor = document.createElement('div');
        noteDisplay.appendChild(editor);

        const delta = JSON.parse(note.noteContent);

        this.quillService.quillSetupDisplay(editor, delta);

        document.getElementById(note.dateCreated.toString()).appendChild(noteDisplay);
        i++;
      }
    }
  }

  public ngOnDestroy() {
    if (this.searchSub !== undefined) {
      this.searchSub.unsubscribe();
    }
  }
}

